import { useMemo } from 'react';
import { format } from 'date-fns';

import { Box } from '@rover/kibble/core';
import { Color } from '@rover/kibble/styles';
import { BhCtaButton } from '@rover/pages/src/bright-horizons/HubPage/common/BhCtaButton';
import { useApiBrightHorizonsGlobalBannerRetrieve } from '@rover/rsdk/src/apiClient/latest';
import { isReactNative } from '@rover/rsdk/src/modules/Env/react';
import { DateRangeField } from '@rover/types/src/datetime/DateRange';

import NavbarBannerBHMessage from './NavbarBannerBHMessage';

type Props = {
  startDate?: DateRangeField;
  isBhHub?: boolean;
  isBrightHorizonsNavigation: boolean;
};

const NavbarBannerBH = ({
  startDate,
  isBhHub,
  isBrightHorizonsNavigation,
}: Props): JSX.Element | null => {
  const formattedStartDate = useMemo(() => {
    return startDate ? format(startDate, 'yyyy-MM-dd') : undefined;
  }, [startDate]);

  const { data } = useApiBrightHorizonsGlobalBannerRetrieve(
    {
      isBhHub,
      startDate: formattedStartDate,
    },
    { query: { enabled: isBrightHorizonsNavigation } }
  );

  if (!isBrightHorizonsNavigation || !data || !data?.bannerMessage) return null;

  const { bannerMessage, button } = data;

  return (
    <Box
      test-id="bh-navbar-banner"
      px="4x"
      pb="3x"
      pt={isReactNative() ? '0x' : '3x'}
      sx={{ backgroundColor: Color.BLUE_100.toString() }}
    >
      <Box
        display={['flex', 'block']}
        flexDirection="column"
        justifyContent="flex-start"
        width={['100%', 'fit-content']}
        sx={{
          gap: '8px',
          margin: '0 auto',
        }}
      >
        <NavbarBannerBHMessage bannerMessage={bannerMessage} />
        {button && (
          <Box display="inline-block">
            <BhCtaButton
              asLink
              size="100"
              fontWeight="semibold"
              cta={button}
              sx={{ cursor: 'pointer' }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NavbarBannerBH;
